import moment from "moment";

export const timeInSeconds = (time: number) => {
  if (!time) {
    return ``
  } else {
    const duration = moment.duration(time, 'seconds');
    const days = Math.floor(duration.asDays());
    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();
    return `${days} dias e ${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
  }
  
}